module.exports = __webpack_public_path__ + "45c57eb98ac328533bc3f83a5af1cd70.svg";